import { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";

interface SetProxyOriginDialogProps {
  open: boolean;
  count: number;
  onClose: () => void;
  onConfirm: (group: string) => void;
}

export function SetProxyOriginDialog(props: SetProxyOriginDialogProps) {
  const { open, count, onClose, onConfirm } = props;
  const [group, setGroup] = useState("");

  const trimmed = group.trim();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Назначить группу прокси</DialogTitle>
      <DialogContent>
        <Typography mb={2}>Введите группу для {count} прокси.</Typography>
        <TextField
          autoFocus
          required
          fullWidth
          size="small"
          label="Группа"
          value={group}
          onChange={(event) => setGroup(event.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Отмена</Button>
        <Button
          variant="contained"
          disabled={trimmed === ""}
          onClick={() => onConfirm(trimmed)}
        >
          Применить
        </Button>
      </DialogActions>
    </Dialog>
  );
}
